export default __webpack_public_path__ + "static/media/mehul.8c0b9686.png";